var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecommended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,8.1l-3-0.4L10.3,5c0-0.1-0.1-0.1-0.2-0.2C10,4.7,9.8,4.8,9.7,5L8.3,7.7l-3,0.4c-0.1,0-0.2,0.1-0.2,0.1 C5.1,8.3,5,8.4,5,8.5c0,0.1,0,0.2,0.1,0.3l2.2,2.1l-0.5,3c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.1,0.1,0.2,0.1 c0.1,0,0.1,0,0.2,0l2.7-1.4l2.7,1.4c0.1,0,0.2,0.1,0.2,0c0.2,0,0.3-0.2,0.3-0.4l-0.5-3l2.2-2.1c0.1-0.1,0.1-0.1,0.1-0.2 C15,8.4,14.8,8.2,14.6,8.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommended);
export default __webpack_public_path__ + "static/media/recommended.471bda2405f12bbc82918bbba70475e4.svg";
export { ForwardRef as ReactComponent };